import { Flex, Icon, Square } from '@chakra-ui/react'
import { CaretRightIcon } from '@editor/assets/icons'
import { EDITOR_TOOL_BUTTON_SIZE } from '@editor/config/constants'
import useLongPress from '@editor/hooks/LongPress'
import { Tooltip } from '@infraloop/common'

interface CameraViewButtonProps {
  ref?: React.Ref<HTMLDivElement>
  /** Tooltip label for the button */
  label: string
  /** Main icon for the button */
  icon: React.ReactElement
  /** Optional secondary icon for the button */
  superIcon?: React.ReactElement
  /** Flag to indicate if the button has a sub-toolbar */
  hasSubtoolbar?: boolean
  /** Flag to indicate if the button is active */
  isActive?: boolean
  /** Flag to indicate if the button is disabled */
  disabled?: boolean
  /** Click handler for the button */
  onClick: () => void
  /** Optional long press handler for the button */
  onLongPress?: () => void
}

const CameraViewButton = ({
  ref,
  label,
  icon,
  superIcon,
  hasSubtoolbar,
  isActive,
  disabled,
  onClick,
  onLongPress,
}: CameraViewButtonProps) => {
  const mouseLongPress = useLongPress(
    { onLongPress: onLongPress || (() => null), onClick },
    { delay: 300, shouldPreventDefault: true },
  )

  return (
    <Tooltip
      showArrow
      positioning={{ placement: 'top' }}
      label={label}
      /* TODO: style migration needed - p=2 */
      /* TODO: style migration needed - fontSize=xs */
      /* TODO: style migration needed - fontWeight=normal */
    >
      <Flex ref={ref} backgroundColor={isActive ? 'secondary.600' : undefined} className="toolbar-button">
        <Square
          position="relative"
          color="white"
          fontSize="xl"
          size={EDITOR_TOOL_BUTTON_SIZE}
          {...mouseLongPress}
          {...(disabled ? { pointerEvents: 'none', opacity: 0.6 } : {})}
        >
          {icon}
          {superIcon && (
            <Square position="absolute" top="1px" right="1px" size="50%">
              {superIcon}
            </Square>
          )}
        </Square>
        {hasSubtoolbar && (
          <Icon
            as={CaretRightIcon}
            boxSize={4}
            marginLeft={1}
            color="white"
            position="absolute"
            top={0}
            right={0}
            transform="rotate(-45deg) translate(45%, 0%)"
          />
        )}
      </Flex>
    </Tooltip>
  )
}

export default CameraViewButton
